module.exports = __webpack_public_path__ + "static/for-individuals-866be3fd430628894609fef78857f1f4.png";